var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dobetter-uploader"},[_c('input',{ref:"fileinput",attrs:{"type":"file","multiple":"multiple","accept":".jpg,.jpeg"},on:{"change":_vm.onFileSelected}}),_c('button',{on:{"click":function($event){return _vm.$refs.fileinput.click()}}},[_vm._v("Datei wählen")])])
}
var staticRenderFns = []

export { render, staticRenderFns }